import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { Api } from '../../../providers';
import { Form } from '../../../providers/survey';
import { FormPage, DetailResponsePage } from '../';

import { UserMyRadiant as User, RepositoryMyRadiant } from '../../../providers';

import { cmpFilterKaryawan } from "../../../components/presensi";

@Component({
  selector   : 'page-listFormResponse',
  templateUrl: 'index.html'
})
export class ListFormResponsePage {
  
  profile           : any;
  list_form_response: any=[];
  list_form_response_today: any=[];
  form              : any={};
  form_id = 0;

  today : any;

  count_todays_entry     = 0;
  count_yesterdays_entry = 0;

  user_data         : any={};

  user_id = this.userApi.data.Employee_ID;

  loading : any;

  constructor(
    public navCtrl            : NavController,
    public navParams          : NavParams,
    public loadingCtrl        : LoadingController,
    public toastCtrl          : ToastController,
    public modalCtrl          : ModalController,
    public api                : Api,
    public formApi            : Form,
    public userApi            : User,
    public repositoryMyRadiant: RepositoryMyRadiant
    ) {

    this.form_id = navParams.get('form_id');

    this.user_data = this.userApi.data;
    console.log("data user => ", this.user_data);

  }

  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidEnter() {
    this.getForm()
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getForm();
  }

  public getForm(){
      this.showLoading();
  
      let params:any = {
        form_id : this.form_id
      };
      this.formApi.get(params).subscribe((resp:any) => {
        console.log('getListForm =>',resp);
        if(resp.success){
          this.form  = resp.data[0];
          console.log("form => ", this.form);
          // this.total_data = resp.total_rows;

          this.getListData();
        }
  
        this.loading.dismiss();
      },(err) => {
        console.log(err);
        this.loading.dismiss();
      });
    
  }

  public getListData(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      user_id   : this.user_id,
      form_id   : this.form.id,
      form_name : this.form.form_name
    };

      this.formApi.getListResponse(params).subscribe((resp:any) => {
        console.log("data response => ",resp.data);
        let temp_form_response       = [];
        let temp_form_response_today = [];
        this.count_todays_entry     = 0;
        this.count_yesterdays_entry = 0
        
        resp.data.forEach(data => {
          if(data.date_create == resp.date.today){
            temp_form_response_today.push(data);
            ++this.count_todays_entry;
          }else if(data.date_create == resp.date.yesterday){
            temp_form_response_today.push(data);
            ++this.count_yesterdays_entry;
          }else{
            temp_form_response.push(data);
          }
        });
        console.log("Todays Resp Data => ", temp_form_response_today);
        console.log("Todays entry count => ", this.count_todays_entry);
        console.log("Yesterdays entry count => ", this.count_yesterdays_entry);

        this.list_form_response       = temp_form_response;
        this.list_form_response_today = temp_form_response_today;

        this.today = resp.today;
        loading.dismiss();
      }, (err) => {
        loading.dismiss();     
      });
  }
  
  cekData(){
    this.list_form_response.forEach(data => {
      if(data.date_create==this.today){
        ++this.count_todays_entry;
        this.list_form_response_today.push(data);
      }
      console.log("count todays entry => ", this.count_todays_entry);
    });
  }

  addResponse() {
    this.navCtrl.push(FormPage, {
      form           : this.form,      
      TY_entry_count : {
        today     : this.count_todays_entry,
        yesterday : this.count_yesterdays_entry
      }
    });
  }

  toEditResponse(item) {
    this.navCtrl.push(FormPage, {
      data : item,
      form : this.form,
      TY_entry_count : {
        today     : this.count_todays_entry,
        yesterday : this.count_yesterdays_entry
      }
    });
  }
  toDetailResponse(item) {
    this.navCtrl.push(DetailResponsePage, {
      data : item,
      form : this.form
    });
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  showMyTeamData(){
    let me = this;
    this.showLoading();
    let params = {
      id : this.user_data.Employee_ID
    };
    this.repositoryMyRadiant.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {
          karyawan      : resp.data.list,
          isAddHoc      : resp.data.isAddHoc,
          fiturSearching: true,
          title         : "My Team Profile",
          level         : resp.data.level},
          {cssClass: 'select-modal',
          enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          let u_id;
          if(karyawan){
            if (karyawan=='me') {
              this.user_id = this.user_data.Employee_ID
            }else{
              this.user_id = karyawan.id
            }
            me.getListData();
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }
}



// WEBPACK FOOTER //
// ./src/pages/survey/list_form_response/index.ts